import { darkComponentColors } from "./componentColors";

export const lemmonMidnight = {
  lemmonMidnight: {
    "color-scheme": "dark",
    primary: "#a78bfa",

    "primary-content": "#1a0d2e",

    secondary: "#221d3d",

    "secondary-content": "#fff",

    accent: "#f0abfc",

    "accent-content": "#2a0a2e",

    neutral: "#6b6391",

    "neutral-content": "#fff",

    "base-100": "#191730",

    "base-200": "#141229",
    "base-300": "#0f0d20",
    "base-content": "#c5c2dd",
    "--form-control-background": "#0f0d20",
    "--lemmon-switcher-background": "rgba(167, 139, 250, 0.08)",
    "--lemmon-switcher-border": "rgba(167, 139, 250, 0.15)",
    "--lemmon-switcher-indicator-background": "rgba(167, 139, 250, 0.16)",
    "--lemmon-switcher-indicator-overlay-background":
      "rgba(240, 171, 252, 0.10)",
    "--lemmon-switcher-indicator-shadow": "rgba(0, 0, 0, 0.35) 0px 1px 3px",

    info: "#7dd3fc",

    "info-content": "#001824",

    success: "#34d399",

    "success-content": "#031202",

    warning: "#fcd34d",

    "warning-content": "#1a1300",

    error: "#fb7185",

    "error-content": "#1a0006",

    "--pos-card-bg": "#2c2750",
    "--pos-card-selected-bg": "#141229",
    "--pos-bar-color": "#f0abfc",
    "--body-bg-color": "#141229",
    "--pos-panel-bg": "#1c1936",
    "--pos-border-color": "#332f5c",
    "--pos-shadow-color": "#332f5c",
    "--pos-shadow-highlight": "rgba(255, 255, 255, 0.18)",
    ...darkComponentColors,
    "--floor-plan-background": "#0f0d20",
    "--floor-plan-fixture-background": "#2c2750",
    "--floor-plan-selection-background": "rgba(167,139,250,0.28)",
    "--floor-plan-selection-border": "#a78bfa",
    "--floor-plan-table-busy-background": "#6d55c7",
    "--floor-plan-table-busy-shadow":
      "0 3px 10px rgba(109,85,199,0.38), inset 0 1px 0 rgba(255,255,255,0.12)",
    "--floor-plan-table-reserved-ring": "#fcd34d",
    "--order-card-background": "#2c2750",
    "--order-card-border": "#6b6391",
    "--order-card-dine-in-background": "#514878",
    "--floor-plan-walker-accent-alt": "#f0abfc",
  },
};
